'use client'

import type React from 'react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { MapPin } from 'lucide-react'
import { trackAnalyticsEvent } from '@/lib/analytics'
import { clinicIdentity } from '@/lib/clinic-identity'

// Curated Google Maps pin from the central identity module (replaces the
// old ad-hoc address search string).
const mapsHref = clinicIdentity.maps.placeUrl

const SurrogacyHero: React.FC = () => {
  return (
    <section className="bg-gradient-to-b from-muted/50 to-background">
      <div className="mx-auto max-w-6xl px-4 pb-12 pt-24 sm:px-6 sm:pb-16 sm:pt-16 lg:px-8 lg:pb-20 lg:pt-20">
        {/* Breadcrumb / meta row */}
        <div className="mb-5 flex flex-wrap items-center gap-2 sm:gap-3">
          <Badge className="rounded-full px-3 py-1 text-xs">Services</Badge>
          <span className="text-xs text-muted-foreground sm:text-sm">
            Certificate oriented
          </span>
        </div>

        {/* Heading */}
        <h1 className="mb-4 text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl">
          Surrogacy Evaluations
        </h1>

        {/* Description */}
        <p className="max-w-2xl text-sm text-muted-foreground sm:text-base">
          We offer surrogate evaluations for intended parents applying for a{' '}
          <span className="font-medium text-foreground">
            certificate for Medical Indication
          </span>{' '}
          to undergo gestational surrogacy. A clear, step-by-step pathway with
          comprehensive clinical and psychological review.
        </p>

        {/* CTAs */}
        <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-3">
          <Button asChild className="w-full sm:w-auto">
            <a href="/book?service=surrogacy-evaluation">
              Book Surrogacy Evaluation
            </a>
          </Button>
          <Button variant="outline" asChild className="w-full sm:w-auto">
            <a
              href={mapsHref}
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                trackAnalyticsEvent('directions_click', {
                  cta_location: 'surrogacy_hero',
                })
              }
            >
              <MapPin className="mr-2 h-4 w-4 shrink-0" />
              Get Directions
            </a>
          </Button>
        </div>
      </div>
    </section>
  )
}

export default SurrogacyHero
